import { ApiMananger } from "actions/rtkquery";
import { PIECES_COMPTABLES_API_ROUTE, PIECES_COMPTABLES_STATS_API_ROUTE, RAPPROCHEMENT_PIECES_API_ROUTE } from "routes/api/endpoints";

export const INVALIDATE_PIECES = "PIECES_COMPTABLES";

const piecesApi = ApiMananger.injectEndpoints({
  endpoints: (build) => ({
    getPiecesComptables: build.query({
      query: ({ dossier_id, folder, doc_type, search }) => {
        let url = `${PIECES_COMPTABLES_API_ROUTE}?dossier_id=${dossier_id}`;
        if (folder && folder !== "all") url += `&folder=${encodeURIComponent(folder)}`;
        if (doc_type && doc_type !== "all") url += `&doc_type=${encodeURIComponent(doc_type)}`;
        if (search) url += `&search=${encodeURIComponent(search)}`;
        return url;
      },
      providesTags: [INVALIDATE_PIECES],
    }),

    getPiecesStats: build.query({
      query: ({ dossier_id }) => `${PIECES_COMPTABLES_STATS_API_ROUTE}?dossier_id=${dossier_id}`,
      providesTags: [INVALIDATE_PIECES],
    }),

    getRapprochementPieces: build.query({
      query: ({ dossier_id }) => `${RAPPROCHEMENT_PIECES_API_ROUTE}?dossier_id=${dossier_id}`,
      providesTags: [INVALIDATE_PIECES],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetPiecesComptablesQuery,
  useGetPiecesStatsQuery,
  useGetRapprochementPiecesQuery,
  useLazyGetRapprochementPiecesQuery,
} = piecesApi;
